import Vue from 'vue';

/**
 * 首字母大写
 * @param str 字符串
 * @example homeTest
 * @return {string} HomeTest
 */
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * 对符合'xx/xx.vue'组件格式的组件取组件名
 * @param str fileName
 * @example home/HomeTest.vue
 * @return {string} HomeTest
 */
function validateFileName(str) {
  return (
    /^\S+\.vue$/.test(str) &&
    str.replace(/^\S+\/(\w+)\.vue$/, (rs, $1) => capitalizeFirstLetter($1))
  );
}

/**
 * 创建全局vue组件
 */
const requireCliComponent = require.context('./', true, /\.vue$/);
const requireSrcComponent = require.context('../components/global', true, /\.vue$/);

// 找到组件文件夹下以.vue命名的文件，如果文件名为index，那么取组件中的name作为注册的组件名

// 执行cli组件
requireCliComponent.keys().forEach(filePath => {
  const componentConfig = requireCliComponent(filePath);
  const fileName = validateFileName(filePath);
  const componentName = fileName;
  Vue.component(componentName, componentConfig.default || componentConfig);
});

// 执行src/compoents组件
requireSrcComponent.keys().forEach(filePath => {
  const componentConfig = requireSrcComponent(filePath);
  const fileName = validateFileName(filePath);
  const componentName = fileName;
  Vue.component(componentName, componentConfig.default || componentConfig);
});
